import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  phoneNumber: string;
};

export const HomeExpiredCalled: FC<Props> = ({ phoneNumber }) => (
  <div className="banner-customers__subtitle">
    <b>
      <FormattedMessage
        id="home-expired/components/Called.tsx/1"
        values={{ br: <br /> }}
      />
      {phoneNumber && (
        <span>
          {' '}
          <FormattedMessage
            id="home-expired/components/Called.tsx/2"
            values={{ phoneNumber }}
          />
        </span>
      )}
    </b>
  </div>
);
